export const breakpoints = {
  mobile: 768,
  tablet: 1024,
  startDesktop: 1100,
  middleDesktop: 1280,
  largeDesktop: 1600,
} as const
